"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { motion } from "framer-motion"
import { Copy, CheckCircle, AlertCircle, Clock } from "lucide-react"
import "../styles/checkout.css"

const CheckoutPix = ({ pedidoId, total, nomeVaqueiro, eventoid, nomeEvento, onSuccess }) => {
  const [qrCode, setQrCode] = useState(null)
  const [pixCopiaCola, setPixCopiaCola] = useState("")
  const [erro, setErro] = useState("")
  const [expiraEm, setExpiraEm] = useState(null)
  const [contador, setContador] = useState("")
  const [copiado, setCopiado] = useState(false)
  const [expirado, setExpirado] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (typeof window === "undefined") return; // Evita SSR
    const metodoAtual = "pix";
    const metodoSelecionado = sessionStorage.getItem("metodoSelecionado");
  
    if (metodoSelecionado !== metodoAtual) return;
    const gerarPix = async () => {
      setLoading(true)
      try {
        const usuarioLogado = JSON.parse(localStorage.getItem("user"))
        if (!usuarioLogado || !usuarioLogado.email || !usuarioLogado.cpf) {
          setErro("Erro ao obter informações do usuário. Faça login novamente.")
          setLoading(false)
          return
        }

        console.log("🧪 Verificação antes do envio do Pix:")
        console.log("usuarioLogado:", usuarioLogado)
        console.log("nome:", usuarioLogado?.nomeCompleto)
        console.log("email:", usuarioLogado?.email)
        console.log("cpf:", usuarioLogado?.cpf)
        console.log("total:", total)
        console.log("eventoid:", eventoid)
        console.log("nomeEvento:", nomeEvento)

        const nomeCompleto = usuarioLogado.nomeCompleto || "Cliente"
        const partesNome = nomeCompleto.trim().split(/\s+/)
        const primeiroNome = partesNome[0] || "Cliente"
        const ultimoNome = partesNome.slice(1).join(" ") || "Sobrenome"
        const nomeEventoFinal = nomeEvento || "Evento não identificado"


        const dadosPagamento = {
          pedidoId,
          totalPedido: total,
          email: usuarioLogado.email,
          nomeVaqueiro,
          eventoid,
          nomeEvento,
          identificationType: "CPF",
          identificationNumber: usuarioLogado.cpf,
          firstName: primeiroNome,
          lastName: ultimoNome, // ✅ agora enviado
          items: [
            {
              id: pedidoId.toString(),
              title: "Ingresso",
              quantity: 1,
              unit_price: Number(total),
              category_id: "event_ticket",
              description: `Compra de ingresso para o evento ${nomeEventoFinal}`
            }
          ]
        }

        console.log("📦 Enviando dados do Pix:", dadosPagamento)

        const response = await axios.post("https://api.ticketdovaqueiro.com/api/pagamento/pix", dadosPagamento)

        if (response.status === 201 && response.data.pagamentoPix) {
          const pixData = response.data.pagamentoPix
          setQrCode(pixData.qr_code_base64)
          setPixCopiaCola(pixData.qr_code)
          // Enviar mensagem via WhatsApp com o Pix gerado
          if (!usuarioLogado.whatsapp || usuarioLogado.whatsapp.trim().length < 10) {
  console.warn("⚠️ Número de WhatsApp ausente ou inválido:", usuarioLogado.whatsapp);
  return;
}
          await axios.post("https://api.ticketdovaqueiro.com/api/zapi/enviar-mensagem-pix", {
            telefone: usuarioLogado.whatsapp,
            nomeVaqueiro,
            pedidoId,
            valor: total,
            qrCodeBase64: pixData.qr_code_base64,
            codigoPix: pixData.qr_code
          });
          console.log("☎️ Enviando Pix para:", usuarioLogado.whatsapp);



          const dataExp = new Date(pixData.expiracao)
          if (!isNaN(dataExp.getTime())) {
            setExpiraEm(dataExp)
          } else {
            setExpiraEm(null)
          }
        } else {
          throw new Error("Erro ao gerar Pix")
        }
      } catch (error) {
        console.error("Erro ao gerar Pix:", error.response?.data || error.message)
        setErro("Erro ao processar pagamento via Pix. Tente novamente.")
      } finally {
        setLoading(false)
      }
    }

    gerarPix()
  }, [pedidoId, total, nomeVaqueiro, eventoid, nomeEvento])

  useEffect(() => {
    if (!expiraEm) return
    const interval = setInterval(() => {
      const agora = new Date()
      const diferenca = expiraEm - agora
      if (diferenca <= 0) {
        setContador("Expirado")
        setExpirado(true)
        clearInterval(interval)
      } else {
        const minutos = Math.floor(diferenca / 60000)
        const segundos = Math.floor((diferenca % 60000) / 1000)
        setContador(`${minutos.toString().padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [expiraEm])

  const copiarCodigo = () => {
    navigator.clipboard.writeText(pixCopiaCola)
    setCopiado(true)
    setTimeout(() => setCopiado(false), 2000)
  }

  if (loading) {
    return (
      <div className="pix-loading">
        <div className="loading-spinner"></div>
        <p>Gerando QR Code...</p>
      </div>
    )
  }

  if (erro) {
    return (
      <div className="pix-erro">
        <AlertCircle size={24} />
        <p>{erro}</p>
      </div>
    )
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="pix-container"
    >
      <h3>Pagamento via Pix</h3>
      {qrCode && (
        <>
          <p>Escaneie o QR Code abaixo ou copie o código:</p>
          <motion.img
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            src={`data:image/png;base64,${qrCode}`}
            alt="QR Code Pix"
            className="qr-code-img"
          />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="copia-cola-container"
          >
            <input type="text" value={pixCopiaCola} readOnly className="copia-cola-input" />
          </motion.div>

          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={copiarCodigo}
            className="btn-copiar"
            disabled={expirado}
          >
            {copiado ? <CheckCircle size={18} /> : <Copy size={18} />}
            {copiado ? "Código copiado!" : "Copiar Código"}
          </motion.button>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="expiracao-timer"
          >
            <Clock size={16} className="timer-icon" />
            Expira em: {contador || "Carregando..."}
          </motion.p>

          {expirado && (
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="pix-expirado">
              <AlertCircle size={18} />O código Pix expirou. Por favor, gere um novo código para realizar o pagamento.
            </motion.div>
          )}
        </>
      )}
    </motion.div>

  )
}

export default CheckoutPix
